import { render, staticRenderFns } from "./ModalViewInventory.vue?vue&type=template&id=896cbbc0"
import script from "./ModalViewInventory.vue?vue&type=script&lang=js"
export * from "./ModalViewInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports